<template>
  <div id="main">
    <div class="container-md">
      <div class="header" style="display: flex; align-items: center;">
        <div class="tab-list">
          <div class="tab-item" @click="changeMessageType($event, 0)" :class="{active: activeIndex === 0}">全部通知</div>
          <div class="tab-item" @click="changeMessageType($event, 1)" :class="{active: activeIndex === 1}">系统</div>
          <div class="tab-item" @click="changeMessageType($event, 2)" :class="{active: activeIndex === 2}">公告</div>
        </div>
        <div class="btn-box">
          <div class="read-all" :class="{disabled: !dataModel.total_count}" @click="readAll">
            <img class="icon" src="../assets/imgs/homepage/icon-message-read.png" alt="">
            <div class="text">全部标记为已读</div>
          </div>
          <div class="delete-all" :class="{disabled: !dataModel.total_count}" @click="deleteAll">
            <img class="icon" src="../assets/imgs/homepage/icon-message-delete.png" alt="">
            <div class="text">删除所有已读</div>
          </div>
        </div>
      </div>

      <div class="msg-list">
        <div class="no-msg" v-if="!dataModel.msg.length">
          <img class="icon" src="../assets/imgs/homepage/no-message.png" alt="">
          暂无消息
        </div>
        <template v-else>
          <div class="msg-item" :class="{visited: v.status === 1}" v-for="v in dataModel.msg" :key="v.message_id">
            <div class="icon-box">
              <img class="icon" :src="`https://o.666visa.cn/static/ssqpeer/homepage/${v.type === 0?'message-notice1': 'message-sys1'}.png`" alt="">
            </div>
            <div class="content">
              <div class="type-box">
                <div class="type">{{v.type === 0?'公告':'系统'}}</div>
                <div class="time" v-if="v.create_time">{{v.create_time}}</div>
              </div>
              <div class="msg-info">
                <div class="msg" v-if="v.type === 0">
                  【{{v.title}}】{{v.content}}
                  <span class="msg-link" @click="showNotice(v)">点击查看</span>
                </div>
                <div class="msg" v-else>
                  【{{v.title}}】
                  <span v-html="v.content.title"></span>
                  <span class="msg-link" @click="msgHandle(v)" v-if="v.content.page_id">{{v.title == '账号安全提示' ?  '点击修改' : '点击查看'}}</span>
                  <span class="msg-link" @click="adviceMsgHandle(v)" v-else-if="v.title == '意见反馈回复'">点击查看</span>
                </div>
              </div>
            </div>
          </div>
        </template>

      </div>
    </div>
    <el-pagination  class="text-center" @current-change="onPageChange" :current-page="page" :page-size="20" layout="total, prev, pager, next" :total="dataModel.total_count">
    </el-pagination>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import NoticeModal from '@/components/common/modals/notice-modal/notice-modal';
import Http from '../libs/http';
import utils from '../libs/utils';

export default {
  data() {
    return {
      dataModel: {
        total_count: 0,
        msg: [],
      },
      activeIndex: 0,
      page: Number(this.$route.query.page) || 1,
    };
  },

  watch: {
    $route() {
      // this.fetchData();
    },
  },

  methods: {
    msgClick(msg) {
      let url = '';
      if (msg.type === 0) {
        url = '/peer_notice_read';
      } else if (msg.type === 1) {
        url = '/peer_message_read';
      }
      return Http.post(url, { id: msg.id }, { noToast: true }).then(() => {
        msg.status = 1;
        this.$parent.getStats();
      });
    },

    readAll(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      if (!this.dataModel.msg || !this.dataModel.msg.length) return;
      let url = '';
      if (this.activeIndex === 0) {
        url = '/unread_notice_message_read';
      } else if (this.activeIndex === 1) {
        url = '/unread_message_read';
      } else if (this.activeIndex === 2) {
        url = '/unread_notice_read';
      }
      Http.post(url, {}, { noToast: true }).then(() => {
        utils.msg.success('操作成功!');
        this.fetchData();
        this.$parent.getStats();
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    deleteAll(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      if (!this.dataModel.msg || !this.dataModel.msg.length) return;
      utils.msgbox
        .confirm('确定删除所有已读消息？', '删除所有已读', {
          confirmButtonText: '　确定　',
          cancelButtonText: ' 取消 ',
          type: 'warning',
        })
        .then(() => {
          let url = '';
          if (this.activeIndex === 0) {
            url = '/read_notice_message_delete';
          } else if (this.activeIndex === 1) {
            url = '/read_message_delete';
          } else if (this.activeIndex === 2) {
            url = '/read_notice_delete';
          }
          Http.post(url, {}, { noToast: true }).then(() => {
            utils.msg.success('删除成功!');
            this.page = 1;
            this.fetchData();
            this.$parent.getStats();
          }).catch((e) => {
            if (e) console.log(e);
          });
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },

    onPageChange(page) {
      this.page = page || 1;
      this.addQueryToUrl();
      this.fetchData();
    },

    // 往当前URL里面添加query参数
    addQueryToUrl() {
      const query = {
        page: this.page,
        type: this.activeIndex,
      };
      let queryString = '';
      Object.keys(query).forEach((key) => {
        queryString += `${key}=${query[key]}&`;
      });
      queryString = queryString.substring(0, queryString.length - 1);
      window.location.replace(`${window.location.origin}/#${this.$route.path}?${queryString}`);
    },

    changeMessageType(e, type) {
      sensorsdata.quick('trackHeatMap', e.target);
      if (this.activeIndex !== type) {
        this.activeIndex = type;
        this.page = 1;
        this.addQueryToUrl();
        this.fetchData();
      }
    },

    showNotice(item) {
      this.msgClick(item);
      NoticeModal.modal({
        title: item.title,
        message: item.content,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: '我知道了',
        confirmMethod: () => {
        },
        cancelMethod: () => {
        },
      });
    },

    fetchData() {
      let url = '';
      if (this.activeIndex === 0) {
        url = '/peer_notice_message_brief_query';
      } else if (this.activeIndex === 1) {
        url = '/peer_message_brief_query';
      } else if (this.activeIndex === 2) {
        url = '/peer_notice_brief_query';
      }
      this.dataModel.msg = [];
      Http.post(url, { page: this.page }).then((data) => {
        data.msg = data.page_data instanceof Array ? data.page_data : [];
        this.dataModel.msg = data.msg;
        this.dataModel.total_count = data.total_count;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    msgHandle(msg) {
      this.msgClick(msg);
      const { args } = msg.content;
      switch (msg.content.page_id) {
        case 0:
          break;
        case 1:
          this.$router.push({
            name: 'orderDetail',
            params: { oid: args.user_order_id },
          });
          break;
        case 2:
          this.$router.push({ name: 'coupon' });
          break;
        case 3:
          this.$router.push({
            name: 'questionDetail',
            params: { id: args.qa_question_id },
          });
          break;
        case 4:
          this.$router.push({
            name: 'orderEvaluation',
            params: { oid: args.user_order_id },
          });
          break;
        case 5:
          this.$router.push({
            name: 'shop',
          });
          break;
        case 6:
          this.$router.push({
            name: 'profile',
          });
          break;
        case 7:
          this.$router.push({
             path: `/user/equity`
          });
          break;
        default:
          break;
      }
    },
    adviceMsgHandle(item) {
      this.msgClick(item);
      let tips = item.content.advice;
      tips = tips.length > 100 ? `您的反馈：${tips.substring(0, 100)}...` : `您的反馈：${tips}`;
      NoticeModal.modal({
        title: '回复详情',
        message: `上上签回复：${item.content.title}`,
        tips,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: '我知道了',
        confirmMethod: () => {
        },
        cancelMethod: () => {
        },
      });
    },
  },

  created() {
    const type = this.$route.query.type;
    if (type) {
      this.activeIndex = +type;
    }
    this.fetchData();
  },
  beforeRouteLeave(to, from, next) {
    this.$parent.getStats();
    next();
  },
};
</script>

<style lang="less">
@import "../assets/less/variable.less";

.message-wrap #main {
  padding-top: 40px;
  padding-bottom: 30px;

  .container-md {
    border-radius: 2px;
    box-shadow:0px 2px 4px 0px rgba(0,0,0,0.06);
    background-color: white;
  }

  .header {
    font-size: 16px;
    height: 60px;
    display: flex;
    border-bottom: 1px solid #F0F0F0;
    .tab-list{
      flex-grow: 1;
      height: 100%;
      width: 100%;
      padding-left: 38px;
      display: flex;
      .tab-item{
        color: #6F6F6F;
        height: 100%;
        display: flex;
        align-items: center;
        position: relative;
        margin-right: 52px;
        cursor: pointer;
        &.active{
          color: #599FFF;
          font-weight: 600;
          &::after{
            content: '';
            width: 30px;
            height: 4px;
            border-radius: 1px;
            background: #599FFF;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
    .btn-box{
      flex-shrink: 0;
      display: flex;
      align-items: center;
      .read-all{
        display: flex;
        align-items: center;
        color: #2F333D;
        font-size: 14px;
        padding: 0 16px;
        border-right: 1px solid #E9EEF2;
        cursor: pointer;
        &:hover{
          color: #599FFF;
        }
        &.disabled{
          color: #91999F !important;
          cursor: default;
        }
        .icon{
          width: 14px;
          height: 14px;
          margin-right: 2px;
        }
      }
      .delete-all{
        display: flex;
        align-items: center;
        color: #2F333D;
        font-size: 14px;
        padding: 0 16px;
        cursor: pointer;
        &:hover{
          color: #599FFF;
        }
        &.disabled{
          color: #91999F !important;
          cursor: default;
        }
        .icon{
          width: 14px;
          height: 14px;
          margin-right: 2px;
        }
      }
    }
  }

  .el-pagination {
    margin-top: 50px;
  }



  .msg-list {
    padding: 0 24px;
    min-height: 100px;
    .no-msg{
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 42px;
      padding-bottom: 100px;
      color: #91999F;
      font-size: 20px;
      .icon{
        width: 200px;
        height: 138px;
        margin-bottom: 16px;
      }
    }
    .msg-item{
      display: flex;
      padding: 20px 24px 0 24px;
      .icon-box{
        flex-shrink: 0;
        width: 45px;
        height: 52px;
        position: relative;
        margin-right: 24px;
        .icon{
          width: 100%;
          height: 100%;
        }
        &::after{
          content: '';
          border-radius: 100% 100%;
          width:6px;
          height:6px;
          background:rgba(255,100,100,1);
          position: absolute;
          right: 0;
          top: 0;
        }
      }
      .content{
        padding-bottom: 24px;
        flex-grow: 1;
        border-bottom: 1px solid #F0F0F0;
        .type-box{
          display: flex;
          margin-bottom: 12px;
          .type{
            font-size: 16px;
            line-height: 22px;
            color: #5F666E;
            font-weight: 600;
          }
          .time{
            margin-left: 18px;
            font-size:16px;
            line-height:22px;
            color: #91999F;
          }
        }
        .msg-info{
          padding-right: 24px;
          .msg{
            color: #2F333D;
            font-size: 16px;
            line-height: 26px;
            .msg-link{
              color: #599FFF;
              cursor: pointer;
            }
          }
        }
      }
      &.visited{
        .msg{
          color: #C9CDD1 !important;
        }
        .icon-box{
          &::after{
            display: none;
          }
        }
      }
    }
  }


}
</style>



// WEBPACK FOOTER //
// src/pages/Message.vue